<div class="module-page">
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  }

  @if (!loading && !detail) {
    <div class="error-state">
      <p>Module not found.</p>
      <button mat-button (click)="goBack()">← Back to Training</button>
    </div>
  }

  @if (!loading && detail) {
    <div class="module-header">
      <button mat-button class="back-btn" (click)="goBack()">← Training</button>
      <h2 class="module-title">{{ detail.module.title }}</h2>
      <div class="module-meta">
        @if (detail.module.category) {
          <span class="category-chip">{{ detail.module.category }}</span>
        }
        @if (detail.module.estimatedMinutes) {
          <span class="time-badge">~{{ detail.module.estimatedMinutes }} min</span>
        }
      </div>
      @if (detail.module.description) {
        <p class="module-description">{{ detail.module.description }}</p>
      }
    </div>

    <mat-tab-group animationDuration="200ms" (selectedIndexChange)="onTabIndexChange($event)">
      <mat-tab [disabled]="quizInProgress">
        <ng-template mat-tab-label>
          Content
          @if (contentCompleted) {
            <mat-icon class="tab-complete-icon">check_circle</mat-icon>
          }
        </ng-template>
          @if (detail.sections.length === 0) {
            <div class="empty-state">No content available for this module.</div>
          } @else {

            <div class="section-stepper">
              @for (section of detail.sections; track section._id; let i = $index) {
                <div class="step-dot"
                     [class.step-current]="i === sectionIndex"
                     [class.step-done]="isSectionDone(i) && i !== sectionIndex">
                  @if (isSectionDone(i) && i !== sectionIndex) {
                    <mat-icon class="step-check">check</mat-icon>
                  } @else {
                    {{ i + 1 }}
                  }
                </div>
                @if (i < detail.sections.length - 1) {
                  <div class="step-line" [class.step-line-done]="isSectionDone(i)"></div>
                }
              }
            </div>

            @if (currentSection && currentSection.items.length === 0) {
              <div class="empty-section">
                <p>No content in this section yet.</p>
              </div>
            } @else if (currentSection) {
              <app-training-content
                [contentItems]="currentSection.items"
                [moduleId]="detail.module._id"
                [alreadyCompleted]="contentCompleted"
                [isLastSection]="isLastSection"
                [sectionType]="currentSection.type"
                [isActive]="!quizInProgress"
                (sectionDone)="onSectionDone()">
              </app-training-content>
            }

            @if (markingComplete) {
              <div class="marking-row">
                <mat-spinner diameter="20"></mat-spinner>
                <span>Saving…</span>
              </div>
            }

            <div class="section-nav-row">
              @if (isLastSection && contentCompleted) {
                <div class="content-complete-banner">
                  <mat-icon class="complete-check">check_circle</mat-icon>
                  <span>Content complete!@if (hasQuiz) { Ready to take the quiz?}</span>
                </div>
                <span class="section-nav-spacer"></span>
                @if (hasQuiz) {
                  <button mat-raised-button color="primary" (click)="goToQuiz()">
                    Take the Quiz →
                  </button>
                }
              } @else {
                @if (sectionIndex > 0) {
                  <button mat-stroked-button (click)="prevSection()">← Previous Section</button>
                }
                <span class="section-nav-spacer"></span>
                @if (!isLastSection) {
                  <button mat-raised-button color="primary"
                          [disabled]="!currentSectionCompleted"
                          (click)="nextSection()">
                    Next Section →
                  </button>
                }
                @if (isLastSection && hasQuiz) {
                  <button mat-raised-button color="primary"
                          [disabled]="!currentSectionCompleted"
                          (click)="goToQuiz()">
                    Take the Quiz →
                  </button>
                }
              }
            </div>

          }
      </mat-tab>

      <mat-tab label="Quiz" [disabled]="!contentCompleted">
        <ng-template matTabContent>
          <app-training-quiz [moduleId]="detail.module._id"
            (submitted)="onQuizSubmitted()">
          </app-training-quiz>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  }
</div>
